import { render, staticRenderFns } from "./CommentMedicineItem.vue?vue&type=template&id=7289a22a&"
import script from "./CommentMedicineItem.vue?vue&type=script&lang=js&"
export * from "./CommentMedicineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports